import React, {Component} from "react";
import PropTypes from "prop-types";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import queryString from "query-string";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import OrgChart from "./OrgChart";
import i18next from "i18next";

class ViewPersonRender extends Component {
    getImageUrl = ()=> {
        const qs = queryString.stringify({tabNum:this.props.tabNum});
        const actionName = !this.props.tabNum ? "GetMyProfileImage" : "GetPersonImage";
        return window.config.apiRoot + "/PaPersonImage/" + actionName + "?" + qs;
    };

    renderPersonPhoto = () => {
        return <div className="m-2 d-block"><img src={this.getImageUrl()} alt="Person Image" /></div>;
    };

    paramRenderTop = (h) => {
        return (<React.Fragment> {h.fs.map((fi) => {
                    const fn = fi.Name;

                    if (this.props.titleInfo.getField(0, fn) == null)
                        return null;

                    return (
                        <p className={"fs14"} key={fn}>
                            <span className="fs14 text-grey">{h.lbl(fn)}&nbsp;</span>
                            {h.ed(fn)}
                        </p>)
                })}</React.Fragment>)
    };

    paramRender = (h, dataItem) => {
        return (
            <>
                {h.fs.map((fi) => {
                    const fn = fi.Name;

                    if (dataItem.getField(0, fn) == null)
                        return null;

                    return this.renderParamRow(h, fn);
                })}
            </>
        );
    };

    renderParamRow = (h, fn) => {
        let innerControl = "";
        if (fn === "ListTab" || fn === "ListTabelName") {
            if (!h.row[fn]) {
                return null;
            }
            innerControl = <span>{h.row[fn].split('\n').map((r, i) => (
                <React.Fragment key={fn + i.toString()}>
                    {r}<br/>
                </React.Fragment>
            ))}</span>;
        }
        else {
            innerControl = h.ed(fn);
        }

        return (
            <React.Fragment key={fn}>
                <div className="row">
                    <div className="col-md-4 field-title">
                        {h.lbl(fn)}
                    </div>
                    <div className="col-md-8">
                        {innerControl}
                    </div>
                </div>
                <hr className="m-1"/>
            </React.Fragment>
        );
    };

    renderDescribeTab = () => {
        return (
            <PlaceholderWrapper placeholderId="10" title={i18next.t("EmployeeInfo")}>
                <div className={"row"}>
                    <div className="col-md-3 align-content-center" style={{textAlign: "center"}}>
                        {this.renderPersonPhoto()}
                    </div>
                    <div className={"col-md-1"} />
                    <div className={"col-md-8"}>
                        <h1>{this.props.detailsInfo.getField(0, "PreferredName")}</h1>
                        <div className={"row"}>
                            <div className={"col-md-12"}>
                                <ComplexParam dataItem={this.props.titleInfo} readOnly={true} showApplyButton={false} showSearchBar={false} renderParams={this.paramRenderTop} />
                            </div>
                        </div>
                    </div>
                </div>
            </PlaceholderWrapper>
        );
    };

    renderGeneralInfo = () => {
        return (
            <PlaceholderWrapper placeholderId="20" title={i18next.t("GeneralInfo")}>
                <ComplexParam dataItem={this.props.generalInfo} readOnly={true} showApplyButton={false} showSearchBar={false} renderParams={(h) => this.paramRender(h, this.props.generalInfo)} />
            </PlaceholderWrapper>
        );
    };

    renderFullDetails = () => {
        const save = async () => {
            await this.props.dispatch(this.props.detailsInfo.save(0));
            //await this.props.dispatch(this.props.detailsInfo.save(this.props.detailsInfo.rowInEditIndex));
        }
        return (
            <PlaceholderWrapper placeholderId="30" collapsed title={i18next.t("AdditionalInfo")}>
                <ComplexParam dataItem={this.props.detailsInfo} readOnly={false} showApplyButton={false}
                              showSearchBar={false} renderParams={(h) => this.paramRender(h, this.props.detailsInfo)}/>
                <button type="button" className="btn btn-regular -goahead" onClick={save}>
                    {i18next.t("Save")}
                </button>
            </PlaceholderWrapper>);
    }

    renderOrgChart = () => {
        return (
            <PlaceholderWrapper placeholderId="40" title={i18next.t("OrganizationChart")}>
                <OrgChart dataItem={this.props.treeInfo} tabNum={this.props.tabNum} />
            </PlaceholderWrapper>
        );
    };

    render() {
        return (
            <div>
                {this.renderDescribeTab()}
                {this.renderGeneralInfo()}
                {this.renderFullDetails()}
                {this.renderOrgChart()}
            </div>
        );
    }

}

ViewPersonRender.propTypes = {
    dispatch: PropTypes.func.isRequired,
    titleInfo: PropTypes.object.isRequired,
    generalInfo: PropTypes.object.isRequired,
    detailsInfo: PropTypes.object.isRequired,
    treeInfo: PropTypes.object.isRequired,
    tabNum: PropTypes.string.isRequired
};

ViewPersonRender.defaultProps = {};

export default ViewPersonRender